import { useTranslation } from "react-i18next";

import { ClientStatus } from "types";

import classes from "./ClientStatusFilterBar.module.css";

interface FilterOption {
  id: ClientStatus;
  labelKey: string;
}

const MAIN_FILTERS: FilterOption[] = [
  { id: "ACTIVE", labelKey: "clientStatusFilters.active" },
  { id: "COMPLETED", labelKey: "clientStatusFilters.completed" },
  { id: "UNASSIGNED", labelKey: "clientStatusFilters.unassigned" },
  { id: "RESERVED", labelKey: "clientStatusFilters.reserved" },
  { id: "BLACKLISTED", labelKey: "clientStatusFilters.blacklisted" },
  { id: "ARCHIVED", labelKey: "clientStatusFilters.archived" },
];

interface ClientStatusFilterBarProps {
  value: ClientStatus;
  onChange: (value: ClientStatus) => void;
}

const ClientStatusFilterBar = ({ value, onChange }: ClientStatusFilterBarProps) => {
  const { t } = useTranslation();

  return (
    <div className={classes.wrapper}>
      <div className={classes.group}>
        {MAIN_FILTERS.map((filter) => (
          <button
            key={filter.id}
            type="button"
            className={`${classes.filterButton} ${value === filter.id ? classes.filterButtonActive : ""}`}
            onClick={() => onChange(filter.id)}
          >
            <span>{t(filter.labelKey)}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default ClientStatusFilterBar;
